import { SiteVersion } from 'app/consts/context';

const SITE_VERSION_KEY = 'siteVersion';

export const getSiteVersionItem = () => localStorage.getItem(SITE_VERSION_KEY);
export const setSiteVersionItem = (siteVersion: SiteVersion) => localStorage.setItem(SITE_VERSION_KEY, siteVersion);
